export default __webpack_public_path__ + "static/media/1864.34771100.png";